//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const StyleEditorMode: FeatureFlag = {"Id":"StyleEditorMode","Label":"Enable Tenant Style Editor mode","Impact":"Don't cache styles in browser so tenant design updates are immediately testable","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":4};
